import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import './ExpertGate.css';

/**
 * Garde des routes expertes (Lot B). Une URL experte visitée en mode simple
 * n'est jamais une erreur : on explique et on propose d'activer le mode.
 * Exception : une action lancée par le Génie (deep-link ?audit / ?tool /
 * ?focusInstance ou state.focusInstance) ouvre l'outil directement — jamais de mur.
 */
export default function ExpertGate({ children }) {
  const { expertMode, toggleExpertMode } = useApp();
  const navigate = useNavigate();
  const location = useLocation();

  const fromGenie = /[?&](audit|tool|focusInstance)=/.test(location.search || '')
    || !!location.state?.focusInstance;

  if (expertMode || fromGenie) return children;

  return (
    <div className="xgate">
      <div className="xgate-card">
        <div className="xgate-icon">🎛️</div>
        <h2 className="xgate-title">Cet outil fait partie du mode expert</h2>
        <p className="xgate-desc">
          Stratégie complète, Studio et Analytics détaillés sont réservés au mode expert —
          pour garder ton menu simple au quotidien. Tu peux l'activer en un clic,
          et le désactiver quand tu veux.
        </p>
        <div className="xgate-actions">
          <button className="xgate-back" onClick={() => navigate('/dashboard')}>← Retour à l'accueil</button>
          <button className="xgate-go" onClick={toggleExpertMode}>🎛️ Activer le mode expert</button>
        </div>
      </div>
    </div>
  );
}
